import { Injector, NgModule } from "@angular/core";
import { HomeComponent } from "./home/home.component";
import { AppComponent } from "./app.component";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { ContactComponent } from "./help/contact/contact.component";
import { HelpComponent } from "./help/help/help.component";
import { TableSortService } from "./services/table-sort.service";
import { AdministrationModule } from "./administration/administration.module";
import { MenuModule } from "./menu/menu.module";
import { CustomErrorComponent } from "./shared/error-page/custom-error-page.component";
import { environment } from "../environments/environment";
import { CalAngularModule } from "@cvx/cal-angular";
import { AppRoutingModule } from "./app-routing.module";
import { TokenInterceptor } from "./interceptors/token-interceptor";
import { ERTUserModule } from "./ert-user/ert-user.module";
import { ERTEducationModule } from "./ert-education/ert-education.module";
import { ERTKR998Module } from "./ert-kr998/ert-kr998.module";
import { ERTEmergencyResponseModule } from "./ert-emergency-response/ert-emergency-response.module";
import { ERTUserViewModule } from "./ert-user/ert-user-view/ert-user-view.module";
import { ERTPreplanRescueModule } from "./ert-preplan-rescue/ert-preplan-rescue.module";
import { ERTFiredepartmentBcTurnoverModule } from "./ert-firedepartment-bc-turnover/ert-firedepartment-bc-turnover.module";
import { DatePipe } from "@angular/common";
const componentList = [
  AppComponent,
  ContactComponent,
  HelpComponent,
  HomeComponent,
  CustomErrorComponent,
];

@NgModule({
  declarations: [componentList],
  imports: [
    HttpClientModule,
    AdministrationModule,
    ERTUserModule,
    ERTEducationModule,
    ERTKR998Module,
    ERTEmergencyResponseModule,
    ERTPreplanRescueModule,
    ERTFiredepartmentBcTurnoverModule,
    MenuModule,
    ERTUserViewModule,
    AppRoutingModule,
    CalAngularModule.forRoot({
      autoSignIn: true,
      popupForLogin: false,
      cacheLocation: "localStorage",
      instance: "https://login.microsoftonline.com/",
      tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
      clientId: environment.clientId,
      redirectUri: "/auth",
      oidcScopes: ["openid", "profile", "User.Read", "offline_access"],
      graphScopes: ["User.Read", "User.Read.All", "Group.Read.All"],
    }),
  ],
  exports: [],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    // ...(environment.production
    //   ? [
    //       {
    //         provide: HTTP_INTERCEPTORS,
    //         useClass: HttpErrorInterceptor,
    //         multi: true,
    //       },
    //     ]
    //   : []),
    TableSortService,
    DatePipe,
  ],
})
export class AppTest {
  constructor(private injector: Injector) {}
}
